const Env = {
  ENV_NAME: process.env.EXPO_PUBLIC_ENV_NAME,
  API_HOST: process.env.EXPO_PUBLIC_API_HOST,
  INSURANCE_URL: process.env.EXPO_PUBLIC_INSURANCE_URL,
  INSURANCE_AUTO_URL: process.env.EXPO_PUBLIC_INSURANCE_AUTO_URL,
  PSF_AUTH_HOST: process.env.EXPO_PUBLIC_PSF_AUTH_HOST,
  PSF_SERVICES_HOST: process.env.EXPO_PUBLIC_PSF_SERVICES_HOST,
  HIBRYS_HOST: process.env.EXPO_PUBLIC_HIBRYS_HOST,
  SALE_FUNNEL_TAKES_CARE_PRODUCT_CODE:
    process.env.EXPO_PUBLIC_SALE_FUNNEL_TAKES_CARE_PRODUCT_CODE,
  SALE_FUNNEL_BAG_PROTECTION_PRODUCT_CODE:
    process.env.EXPO_PUBLIC_SALE_FUNNEL_BAG_PROTECTION_PRODUCT_CODE,
  SALE_FUNNEL_INCOME_PROTECTION_PRODUCT_CODE:
    process.env.EXPO_PUBLIC_SALE_FUNNEL_INCOME_PROTECTION_PRODUCT_CODE,
  SALE_FUNNEL_AUTO_PRODUCT_CODE:
    process.env.EXPO_PUBLIC_SALE_FUNNEL_AUTO_PRODUCT_CODE,
  AUTO_SUPPLIER_ID: process.env.EXPO_PUBLIC_AUTO_SUPPLIER_ID,
  AUTO_LANDING_PAGE_ID: process.env.EXPO_PUBLIC_AUTO_LANDING_PAGE_ID,
  AUTO_ORIGIN_ID: process.env.EXPO_PUBLIC_AUTO_ORIGIN_ID,
  SALE_FUNNEL_ODONTO_PROTECTION_CODE:
    process.env.EXPO_PUBLIC_SALE_FUNNEL_ODONTO_PROTECTION_CODE,
  BANNER_URL: process.env.EXPO_PUBLIC_BANNER_URL,
  BANNER_API_SECRET: process.env.EXPO_PUBLIC_BANNER_API_SECRET,
  BANNER_API_APP: process.env.EXPO_PUBLIC_BANNER_API_APP,
  BAG_PROTECTION_LINK: process.env.EXPO_PUBLIC_BAG_PROTECTION_LINK,
  MARISA_TAKES_CARE_LINK: process.env.EXPO_PUBLIC_MARISA_TAKES_CARE_LINK,
  MY_INSURENCE: process.env.EXPO_PUBLIC_MY_INSURANCE_LINK,
  MARISA_CARD_REQUEST: process.env.EXPO_PUBLIC_MARISA_CARD_REQUEST,
};

export default Env;
